module.exports = __webpack_public_path__ + "img/51626501_L.81953f98.png";